(function() {
  'use strict';

  angular
    .module('survey.essay', ['factories.mobileHelper', 'survey.essayDirective'])
    .controller('EssayCtrl', EssayCtrl);

  EssayCtrl.$inject = ['$scope'];

  function EssayCtrl($scope) {
    function setup() {
      if (!$scope.currentSlide.question || !$scope.currentSlide.question.answer)
        return;

      $scope.state.slideIsDirty = false;

      if ($scope.currentSlide.question.answer)
        $scope.state.answerSelected = true;
    }

    setup();

    $scope.textChanged = function() {
      $scope.state.answerSelected = $scope.currentSlide.question.answer.length > 0;
    };
  }
})();
